// Универсальная модалка с заголовком + контентом + кнопкой «Закрыть».
// Используется для истории валют, лора, справки и любых других экранов
// «информация», которые не нужно выносить в отдельный route.

import { ReactNode } from 'react';
import styles from './InfoModal.module.css';

interface Props {
  title: string;
  onClose: () => void;
  children: ReactNode;
  // Опциональный размер: 'auto' (по контенту, не больше 80vh) / 'tall' (90vh)
  size?: 'auto' | 'tall';
}

export function InfoModal({ title, onClose, children, size = 'auto' }: Props) {
  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div
        className={`${styles.dialog} ${size === 'tall' ? styles.tall : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <header className={styles.header}>
          <h3 className={styles.title}>{title}</h3>
          <button className={styles.close} onClick={onClose} aria-label="Закрыть">×</button>
        </header>
        <div className={styles.body}>{children}</div>
        <footer className={styles.footer}>
          <button className={styles.closeBtn} onClick={onClose}>ЗАКРЫТЬ</button>
        </footer>
      </div>
    </div>
  );
}
